import React, { memo, useRef } from 'react';

// Style
import './Accordion.scss';

// Classes
import clsx from 'clsx';

// Components
import Img from 'components/Img';

// Interface
interface IAccordion {
	style?: object;
	title?: string;
	isOpen?: boolean;
	className?: string;
	header?: React.ReactNode,
	callBack?: (e: any) => void;
	headerEnd?: React.ReactNode;
	classNameTitle?: string;
	classNameContent?: string;
	onToggle?: (isOpen: boolean) => void;
	children?: React.ReactNode | string;
	ref?: React.RefObject<HTMLDetailsElement>;
}

// Component
const Accordion: React.FC<IAccordion> = memo((props) => {
	const {
		style,
		title,
		isOpen,
		header,
		callBack,
		children,
		headerEnd,
		className,
		classNameTitle,
		classNameContent,
		onToggle,
	} = props;
	const detailsRef = useRef<HTMLDetailsElement>(null);

	const handleToggle = () => {
		if (detailsRef.current && onToggle) {
			onToggle(detailsRef.current?.open);
		}
	};

	const cn = clsx(
		'accordion',
		className ? className : ''
	);

	const cnTitle = clsx(
		'accordion__title flex flex-ai-center',
		title ? 'flex-jc-between' : '',
		header ? 'flex-ai-start' : '',
		headerEnd ? 'flex flex-ai-center flex-jc-between' : '',
		classNameTitle ? classNameTitle : ''
	);

	const cnContent = clsx(
		'accordion__content',
		classNameContent ? classNameContent : ''
	);

	return (
		<details
			ref={detailsRef}
			open={isOpen}
			className={cn}
			onToggle={handleToggle}
			onClick={
				callBack
					? (e) => callBack(e)
					: () => {}
			}
		>
			<summary className={cnTitle}>
				{title}
				{header}
				{headerEnd && (
					<div className="flex flex-ai-center">
						{headerEnd}
						<div className="accordion__wrapper-icon">
							<Img isSvg name="arrowAccordionSvg" />
						</div>
					</div>
				)}
				{!headerEnd && <div className="accordion__wrapper-icon">
					<Img isSvg name="arrowAccordionSvg" />
				</div>}
			</summary>
			<div style={style} className={cnContent}>
				{children}
			</div>
		</details>
	);
});

export default Accordion;
